module.exports = __webpack_public_path__ + "img/首页banner.489375b7.png";